import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import React from 'react';

import { ICreateLocationButtonProps } from './types';

const CreateLocationButton: React.FC<ICreateLocationButtonProps> = ({ onClick }) => (
  <ButtonWithSpinner onClick={onClick}>+ Location</ButtonWithSpinner>
);

export default React.memo(CreateLocationButton);
